import { useParams } from 'react-router';
import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import defaultImage from "../../assets/svg/defultImage.svg";
import noteIcon from "../../assets/svg/note-1-svgrepo-com 1.svg";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from 'react-router';
import { Modal } from 'react-bootstrap';
import { CancelOutlined, CheckCircleOutlineOutlined, ChevronLeft, DriveFolderUpload, PauseCircleOutlineOutlined, PlayCircleOutline } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { newHost } from '../../pages/Categories/CategoryProfile';
import { newImageUrl } from '../../pages/Manufacturers/ManufactureProfile';
import { Accordion, AccordionDetails, AccordionSummary, Box, Chip, Dialog, List, ListItemButton, ListItemIcon, ListItemText, Popover, } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CircleIcon from "@mui/icons-material/Circle";
import { useSelector } from 'react-redux';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const ExecuteByService = () => {
    const { user } = useSelector((state) => state.auth);
    const { id: orderId } = useParams()
    const token = sessionStorage.getItem("token");
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true)
    const [currentStaff, setCurrentStaff] = useState(null);
    const [isAllItemsDone, setIsAllItemsDone] = useState(false);
    const [isItemInProgress, setIsItemInProgress] = useState(false);
    const [isAfterImagesUploaded, setIsAfterImagesUploaded] = useState(false);
    const [expandedOrder, setExpandedOrder] = useState(null);


    const getOrders = async () => {
        try {
            const response = await axios.get(
                `${newHost}stuff/get-order-products/${orderId}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            const order = response.data.data?.data;

            const progressingItem = ["in_progress", "paused"]


            const completedStatuses = ["executed", "failed", "rejected"];

            const hasUnfinishedItems = order.categories.some(category =>
                category.subcategories?.some(sub =>
                    sub.items?.some(item => {

                        if (item.item_type === "other_request_adjustment") {
                            return false;
                        }

                        if (
                            item.item_type === "other_request_service" &&
                            item.status !== "accepted_by_user"
                        ) {
                            return false;
                        }

                        return !completedStatuses.includes(item.executions?.status);
                    })
                )
            );
            const hasItemInProgress = order?.categories?.some(category =>
                category.subcategories?.some(sub =>
                    sub.items?.some(
                        item => progressingItem.includes(item.executions?.status)
                    )
                )
            );


            setIsAllItemsDone(!hasUnfinishedItems);
            setIsItemInProgress(hasItemInProgress);
            setOrder(order)



        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };




    const getImagesAfter = async () => {
        try {
            const response = await axios.get(
                `${newHost}stuff/get-after-images/${orderId}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            const images = response.data.data?.images_after || [];
            setIsAfterImagesUploaded(images.length > 0);

        } catch (error) {
            console.log(error.response);
        }
    };
    useEffect(() => {
        getOrders()
        getImagesAfter()
    }, [])


    const [showModal, setShowModal] = useState(false);
    const [noteValue, setNoteValue] = useState("");
    const [executionId, setExecutionId] = useState(null);
   



    const openModal = (id) => {
        setShowModal(true);
        setExecutionId(id)
    }
    const closeModal = () => {
        setShowModal(false);
        setExecutionId(null)
        setNoteValue("")
    }
    const saveNote = async () => {
        try {
            const response = await axios.post(`${newHost}stuff/add-note/${executionId}`, {
                note: noteValue
            }, {
                headers: { Authorization: `Bearer ${token}` }
            })
            toast.success(response.data.message)
            getOrders()

            closeModal()
        } catch (error) {
            toast.error(error.response.data.message)
        }


    };



    const [showExecuteModal, setShowExecuteModal] = useState(false)

    const handleCloseModal = () => {
        setShowExecuteModal(false)
    }

    const endOrderExecution = async () => {

        try {
            const response = await axios.get(`${newHost}stuff/end-execution/${orderId}`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            toast.success(response.data.message)
            handleCloseModal()
            getOrders()

        } catch (error) {
            console.log(error.response);
            toast.error(error.response?.data?.errors?.message)
        }
    }
    const navigate = useNavigate()


    const handleAction = () => {
        if (order.status === "arrived_at_location") {
            navigate(`/ordersExecution/executeByService/${orderId}/imageBefore`, { state: { order } })
        }

        else if (order.status === "in_progress") {

            if (!isAfterImagesUploaded) {
                navigate(`/ordersExecution/executeByService/${orderId}/imageAfter`);
            }
            else {
                setShowExecuteModal(true);
            }
        }

        else if (order.status === "awaiting_payment") {
            navigate(`/ordersExecution/executeByService/${orderId}/confirmPayment`);
        }
    };

    const [orderItemData, setOrderItemData] = useState(null)

    const isDisabled = order?.status !== "in_progress";

    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const startExecute = async (item) => {
        const formData = new FormData()
        formData.append("id", item.id)


        if (item.item_type === "other_request_service") {
            formData.append("type", "other_request")
        } else {
            formData.append("type", "order_item")
        }
        try {
            const response = await axios.post(`${newHost}stuff/start-service/${orderId}`, formData, {
                headers: { Authorization: `Bearer ${token}` }
            })
            toast.success(response.data.message)
            getOrders()
        } catch (error) {
            toast.error(error.response.data.message)
        }
    }



    const endExecute = async (item) => {
        const formData = new FormData()
        formData.append("id", item.id)
        formData.append("status", "executed")

        if (item.item_type === "other_request_service") {
            formData.append("type", "other_request")
        } else {
            formData.append("type", "order_item")
        }

        try {
            const response = await axios.post(`${newHost}stuff/end-service/${orderId}`, formData, {
                headers: { Authorization: `Bearer ${token}` }
            })
            toast.success(response.data.message)
            getOrders()
        } catch (error) {
            toast.error(error.response.data.message)
        }
    }


    const renderServiceRow = (item) => {


        return (
            <div className="border rounded-3 p-3 my-3">
                <div className="d-flex align-items-center justify-content-between my-3">
                    <h6 className="">{item?.service_name}</h6>
                    <div className="d-flex align-items-start gap-2">
                        <h6 className="fw-bold">{`${Number(item?.final_price).toLocaleString("en-US")} ج.م`}</h6>
                        {!item?.executions || !item?.executions?.notes &&
                            <div
                                className="position-relative"
                                onClick={() => openModal(item?.executions?.id)}
                            >
                                <img
                                    src={noteIcon}
                                    alt="note"
                                    style={{
                                        width: 24,
                                        cursor: "pointer",
                                    }}
                                />
                            </div>
                        }

                    </div>
                </div>

                <div className="d-flex align-items-center justify-content-between my-3">
                    <div className="d-flex gap-2">
                        {!item.executions &&
                            <Chip
                                label={
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        gap={1}
                                    >
                                        <CircleIcon
                                            sx={{
                                                fontSize: 10,
                                                color: "#696969",
                                            }}
                                        />
                                        <span>لم تبدأ</span>
                                    </Box>
                                }
                            />}
                        {item.executions?.status === "in_progress" && <Chip
                            sx={{ bgcolor: "#FFFAEA" }}
                            label={
                                <Box
                                    color={"#E29E04"}
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                >
                                    <CircleIcon
                                        sx={{
                                            fontSize: 10,
                                        }}
                                    />
                                    <span>جاري التنفيذ</span>
                                </Box>
                            }
                        />}
                        {item.executions?.status === "paused" &&
                            <Chip
                                sx={{ bgcolor: "#FFFAEA" }}
                                label={
                                    <Box
                                        color={"#E29E04"}
                                        display="flex"
                                        alignItems="center"
                                        gap={1}
                                    >
                                        <CircleIcon
                                            sx={{
                                                fontSize: 10,
                                                color: "#E29E04",
                                            }}
                                        />
                                        <span>متوقفة</span>
                                    </Box>
                                }
                            />}

                        {item.executions?.status === "executed" && <Chip
                            sx={{ bgcolor: "#D8F3EF" }}
                            label={
                                <Box
                                    color={"#159D89"}
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                >
                                    <CircleIcon
                                        sx={{
                                            fontSize: 10,
                                        }}
                                    />
                                    <span>مكتملة</span>
                                </Box>
                            }
                        />}
                        {item.executions?.status === "rejected" && <Chip
                            sx={{ bgcolor: "#FFF4F0" }}
                            label={
                                <Box
                                    color={"#A80101"}
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                >
                                    <CircleIcon
                                        sx={{
                                            fontSize: 10,
                                        }}
                                    />
                                    <span>مرفوضة</span>
                                </Box>
                            }
                        />}
                        {item.executions?.status === "failed" && <Chip
                            sx={{ bgcolor: "#FFF4F0" }}
                            label={
                                <Box
                                    color={"#A80101"}
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                >
                                    <CircleIcon
                                        sx={{
                                            fontSize: 10,
                                        }}
                                    />
                                    <span>فشلت</span>
                                </Box>
                            }
                        />}
                    </div>
                    <div className='text-start'>
                        {item.executions?.started_at &&

                            <div className="">
                                <p className="main-text-color label-size ">
                                    {`تم البدأ ${new Date(item.executions?.started_at).toLocaleDateString()} ${new Date(item.executions?.started_at).toLocaleTimeString()} `}
                                </p>
                            </div>
                        }
                        {item.executions?.ended_at &&

                            <div className="">
                                <p className="main-text-color label-size m-0">
                                    {`تم الانتهاء ${new Date(item.executions?.ended_at).toLocaleDateString()} ${new Date(item.executions?.ended_at).toLocaleTimeString()} `}
                                </p>
                            </div>
                        }
                    </div>

                </div>
                <div className="d-flex align-items-center gap-3 my-3">
                    {!item.executions &&
                        <>
                            <button disabled={isDisabled || isItemInProgress} onClick={() => startExecute(item)} className="px-3 rounded-2 btn btn-dark d-flex gap-1 align-items-center">
                                <PlayCircleOutline fontSize="small" />
                                بدء تنفيذ الخدمة
                            </button>
                            <button
                                disabled={isDisabled || isItemInProgress}
                                onClick={() => openReasonModal("rejected", item)}
                                style={{
                                    border: "1px solid #A80101",
                                    color: "#A80101",
                                }}
                                className="px-3 rounded-2 btn d-flex gap-1 align-items-center"
                            >
                                <CancelOutlined fontSize="small" />
                                رفض الخدمة
                            </button>

                        </>

                    }
                    {item.executions?.status === "in_progress" &&
                        <>
                            <button onClick={handleOpen} className="px-3 rounded-2 btn btn-dark d-flex gap-1 align-items-center">
                                <CheckCircleOutlineOutlined fontSize="small" />
                                انهاء الخدمة
                            </button>
                            <Popover
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "center",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "center",
                                }}
                                PaperProps={{
                                    sx: {
                                        mt: 1,
                                        width: 200,
                                        borderRadius: 3,
                                        p: 1,
                                        boxShadow: "0 8px 24px rgba(0,0,0,.15)",

                                    },
                                }}
                            ><Box>



                                    <List sx={{ py: 1, }}>

                                        <ListItemButton
                                            onClick={() => {
                                                endExecute(item)
                                                handleClose();
                                            }}
                                            sx={{
                                                borderRadius: 2, textAlign: "center",
                                                "& .css-rizt0-MuiTypography-root": {
                                                    fontSize: 18
                                                }
                                            }}
                                        >
                                            <ListItemIcon>
                                                <CheckIcon sx={{ color: "#3FBEAC" }} />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary="تمت الخدمة"
                                            />

                                        </ListItemButton>

                                        <ListItemButton
                                            onClick={() => {
                                                handleClose()
                                                openReasonModal("failed", item)

                                            }}
                                            sx={{
                                                borderRadius: 2, textAlign: "center",
                                                "& .css-rizt0-MuiTypography-root": {
                                                    fontSize: 18
                                                }
                                            }}
                                        >
                                            <ListItemIcon>
                                                <CloseIcon sx={{ color: "#A80101" }} />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary="فشلت الخدمة"
                                            />
                                        </ListItemButton>

                                    </List>

                                </Box>

                            </Popover>
                            <button
                                onClick={() => handlePauseReasonShow(item)}
                                style={{
                                    border: "1px solid #696969",
                                    color: "#696969",
                                }}
                                className="px-3 rounded-2 btn d-flex gap-1 align-items-center"
                            >
                                <PauseCircleOutlineOutlined fontSize="small" />
                                ايقاف مؤقت
                            </button>
                        </>

                    }
                    {item.executions?.status === "paused" &&
                        <>

                            <button
                                onClick={() => handleResume(item)}
                                style={{
                                    border: "1px solid #696969",
                                    color: "#696969",
                                }}
                                className="px-3 rounded-2 btn d-flex gap-1 align-items-center"
                            >
                                <PauseCircleOutlineOutlined fontSize="small" />
                                استمرار
                            </button>
                        </>

                    }


                </div>
                {item.executions && <div className={` my-1 d-flex align-items-center ${item.executions?.status === "executed" ? "justify-content-between" : "justify-content-end"}`}>
                    {item.executions?.status === "executed" &&
                        <div className="d-flex align-items-center gap-2">
                            <CheckIcon />
                            <span>تم اكمال الخدمة بنجاح</span>
                        </div>

                    }
                    {item.executions &&
                        <div className="d-flex justify-content-end ">
                            <IconButton
                                onClick={() => handleServicesDetailsShow(item)}
                                sx={{ fontSize: "14px", color: "#000" }}
                                disableRipple
                                size="small"
                            >
                                عرض التفاصيل
                                <ChevronLeft size={14} />
                            </IconButton>
                        </div>}




                </div>}


            </div>
        );
    };
    const allowedStatuses = [
        "arrived_at_location",
        "in_progress",
        "awaiting_payment"
    ];
    const [servicesDetailsShow, setServicesDetailsShow] = useState(false)

    const handleServicesDetailsShow = (item) => {
        setOrderItemData(item)
        setServicesDetailsShow(true)
    }
    const handleServicesDetailsClose = () => {
        setServicesDetailsShow(false)
    }


    // Pause reason

    const [pauseReasonShow, setPauseReasonShow] = useState(false)
    const [pauseReasons, setPauseReasons] = useState([])
    const [selectedReason, setSelectedReason] = useState(null)
    const [isSelectedOtherReason, setIsSelectedOtherReason] = useState(false)
    const [selectedOtherReason, setSelectedOtherReason] = useState(null)


    const handlePauseReasonShow = (item) => {
        console.log(item);

        setOrderItemData(item)
        setPauseReasonShow(true)
    }
    const handlePauseReasonClose = () => {
        setPauseReasonShow(false)
        setSelectedReason(null)
    }

    const getPauseReasons = async () => {
        try {
            const response = await axios.get(`${newHost}stuff/pause-reasons`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            setPauseReasons(response.data.data)
        } catch (error) {
            console.log(error);

        }
    }

    useEffect(() => {
        getPauseReasons()
    }, [])

    const reasonChange = (reason) => {
        setSelectedReason(reason)
        setIsSelectedOtherReason(false)

    }
    const otherReasonChange = (note) => {
        setIsSelectedOtherReason(true)
        setSelectedOtherReason(note)

    }

    const handlePause = async () => {
        const formData = new FormData()

        formData.append("id", orderItemData?.id);

        if (orderItemData?.item_type === "other_request_service") {
            formData.append("type", "other_request");
        } else {
            formData.append("type", "order_item");
        }
        formData.append("pause_reason", isSelectedOtherReason ? selectedOtherReason : selectedReason.reason_ar)



        try {
            const response = await axios.post(`${newHost}stuff/pause-service/${orderId}`, formData, {
                headers: { Authorization: `Bearer ${token}` }
            })
            toast.success(response.data.message)
            handlePauseReasonClose()
            getOrders()
        } catch (error) {
            toast.error(error.response.data.message)
        }
    }
    const handleResume = async (item) => {
        const formData = new FormData()
        formData.append("id", item.id)


        if (item.item_type === "other_request_service") {
            formData.append("type", "other_request")
        } else {
            formData.append("type", "order_item")
        }
        try {
            const response = await axios.post(`${newHost}stuff/resume-service/${orderId}`,
                formData
                , {
                    headers: { Authorization: `Bearer ${token}` }
                })
            toast.success(response.data.message)
            getOrders()
        } catch (error) {
            toast.error(error.response.data.message)
        }
    }


    const fileInputFailedRef = useRef(null);

    const [rejectFailModal, setRejectFailModal] = useState({
        show: false,
        mode: null,
        itemId: null,
        note: "",
        file: null,
        imagePreview: null,
        isSaved: false,
    });

    const openReasonModal = (mode, item) => {
        setRejectFailModal({
            show: true,
            mode,
            itemId: item.id,
            note: "",
            file: null,
            imagePreview: null,
            isSaved: false,
        });
        if (fileInputFailedRef.current) fileInputFailedRef.current.value = "";
        setOrderItemData(item)
    };

    const closeReasonModal = () => {
        setRejectFailModal({
            show: false,
            mode: null,
            itemId: null,
            note: "",
            file: null,
            imagePreview: null,
            isSaved: false,
        });
        if (fileInputFailedRef.current) fileInputFailedRef.current.value = "";
        setOrderItemData(null)
    };

    const saveReasonNote = (note) => {
        setRejectFailModal(prev => ({
            ...prev,
            note,
            isSaved: true,
        }));
    };

    const ReasonFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setRejectFailModal(prev => ({
                ...prev,
                file,
                imagePreview: reader.result,
            }));
        };
        reader.readAsDataURL(file);
    };

    const handleRemoveReasonImage = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setRejectFailModal(prev => ({
            ...prev,
            file: null,
            imagePreview: null,
        }));
        if (fileInputFailedRef.current) fileInputFailedRef.current.value = "";
    };

    const submitRejectFailAction = async () => {
        const { mode, itemId, note, file } = rejectFailModal;
        const formData = new FormData();
        formData.append("id", itemId);

        if (orderItemData?.item_type === "other_request_service") {
            formData.append("type", "other_request");
        } else {
            formData.append("type", "order_item");
        }

        if (mode === "rejected") {
            formData.append("rejection_reason", note);


        } else {
            formData.append("failed_reason", note);
            formData.append("status", 'failed');
        }

        if (file) {
            formData.append("image", file);
        }

        const url =
            mode === "rejected"
                ? `${newHost}stuff/reject-service/${orderId}`
                : `${newHost}stuff/end-service/${orderId}`;

        try {
            const response = await axios.post(url, formData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success(response.data.message);
            closeReasonModal();
            getOrders();
        } catch (error) {
            toast.error(error.response?.data?.message);
        }
    };
    useEffect(() => {
        if (user) {
            setCurrentStaff(`${user.stuff?.first_name} ${user.stuff?.last_name}`);
        }
    }, []);

    const [openImage, setOpenImage] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    return (
        <>

            <Modal show={servicesDetailsShow} onHide={handleServicesDetailsClose} dialogClassName='custom-modal-campaigns-width'>
                <Modal.Header className='d-flex align-items-center' >
                    <Modal.Title style={{ direction: "rtl" }} className='fw-bold fs-5 text-center w-100 m-0'>
                        تفاصيل الخدمة
                    </Modal.Title>

                </Modal.Header>
                <Modal.Body className='m-2' style={{ direction: "rtl" }}>
                    <div className="my-2">

                        <div className="d-flex justify-content-between align-items-center">
                            <h6 className="m-0">
                                {orderItemData?.service_name}
                            </h6>

                            {orderItemData?.executions?.status === "in_progress" && <Chip
                                sx={{ bgcolor: "#FFFAEA" }}
                                label={
                                    <Box
                                        color={"#E29E04"}
                                        display="flex"
                                        alignItems="center"
                                        gap={1}
                                    >
                                        <CircleIcon
                                            sx={{
                                                fontSize: 10,
                                            }}
                                        />
                                        <span>جاري التنفيذ</span>
                                    </Box>
                                }
                            />}
                            {orderItemData?.executions?.status === "paused" &&
                                <Chip
                                    sx={{ bgcolor: "#FFFAEA" }}
                                    label={
                                        <Box
                                            color={"#E29E04"}
                                            display="flex"
                                            alignItems="center"
                                            gap={1}
                                        >
                                            <CircleIcon
                                                sx={{
                                                    fontSize: 10,
                                                    color: "#E29E04",
                                                }}
                                            />
                                            <span>متوقفة</span>
                                        </Box>
                                    }
                                />}

                            {orderItemData?.executions?.status === "executed" && <Chip
                                sx={{ bgcolor: "#D8F3EF" }}
                                label={
                                    <Box
                                        color={"#159D89"}
                                        display="flex"
                                        alignItems="center"
                                        gap={1}
                                    >
                                        <CircleIcon
                                            sx={{
                                                fontSize: 10,
                                            }}
                                        />
                                        <span>مكتملة</span>
                                    </Box>
                                }
                            />}
                            {orderItemData?.executions?.status === "rejected" && <Chip
                                sx={{ bgcolor: "#FFF4F0" }}
                                label={
                                    <Box
                                        color={"#A80101"}
                                        display="flex"
                                        alignItems="center"
                                        gap={1}
                                    >
                                        <CircleIcon
                                            sx={{
                                                fontSize: 10,
                                            }}
                                        />
                                        <span>مرفوضة</span>
                                    </Box>
                                }
                            />}
                            {orderItemData?.executions?.status === "failed" && <Chip
                                sx={{ bgcolor: "#FFF4F0" }}
                                label={
                                    <Box
                                        color={"#A80101"}
                                        display="flex"
                                        alignItems="center"
                                        gap={1}
                                    >
                                        <CircleIcon
                                            sx={{
                                                fontSize: 10,
                                            }}
                                        />
                                        <span>فشلت</span>
                                    </Box>
                                }
                            />}
                        </div>
                        <div className="row my-3">
                            <div style={{ borderInlineEnd: "2px solid #E8E8E8" }} className="col-md-4 col-12 d-flex justify-content-center">
                                <div className="">
                                    <h6 className="main-text-color">وقت البدء</h6>
                                    <h6 className="label-size fw-bold">{orderItemData?.executions?.started_at ? new Date(orderItemData?.executions?.started_at).toLocaleTimeString() : "-"}</h6>
                                </div>

                            </div>
                            <div style={{ borderInlineEnd: "2px solid #E8E8E8" }} className="col-md-4 col-12 d-flex justify-content-center">
                                <div className="">
                                    <h6 className="main-text-color">مدة التنفيذ</h6>
                                    <h6 className="label-size fw-bold">{`${orderItemData?.executions?.active_duration} د`}</h6>
                                </div>

                            </div>
                            <div className="col-md-4 col-12 d-flex justify-content-center">
                                <div className="">
                                    <h6 className="main-text-color">وقت الانتهاء</h6>
                                    <h6 className="label-size fw-bold">{orderItemData?.executions?.ended_at ? new Date(orderItemData?.executions?.ended_at).toLocaleTimeString() : "-"}</h6>
                                </div>

                            </div>
                        </div>
                        <div className="my-3">
                            <div className="d-flex gap-2 align-items-center">
                                <CircleIcon sx={{ fontSize: 10, color: "#3FBEAC" }} />
                                <h6 className="m-0">المعلومات العامة</h6>
                            </div>
                            <div style={{ borderBlockEnd: "2px solid #E8E8E8" }} className="my-3 d-flex justify-content-between align-items-center pb-3">
                                <h6 className="main-text-color m-0">اسم الفني</h6>
                                <h6 className="m-0">{currentStaff}</h6>
                            </div>
                            <div style={{ borderBlockEnd: "2px solid #E8E8E8" }} className="my-3 d-flex justify-content-between align-items-center pb-3">

                                <h6 className="main-text-color m-0">سعر الخدمة</h6>
                                <h6 className="fw-bold m-0">{`${Number(orderItemData?.service_only_price).toLocaleString("en-US")} ج.م`}</h6>

                            </div>
                            <div style={{ borderBlockEnd: "2px solid #E8E8E8" }} className="my-3 pb-2">
                                <h6 className="main-text-color">ملاحظات الفني</h6>
                                <h6 className="">{orderItemData?.executions?.notes ? orderItemData?.executions?.notes : "-"}</h6>
                            </div>
                            {orderItemData?.executions?.pauses.length > 0 &&
                                orderItemData?.executions?.pauses.map((pause, i, arr) =>
                                    <div style={{ borderBlockEnd: i < arr.length - 1 && "2px solid #E8E8E8" }} className="my-3 pb-2">
                                        <div className="d-flex gap-2 align-items-center">
                                            <CircleIcon sx={{ fontSize: 10, color: "#3FBEAC" }} />
                                            <h6 className="mb-3">توقف الخدمة</h6>
                                        </div>
                                        <div className=" d-flex justify-content-between align-items-center pb-1">
                                            <h6 className="main-text-color">سبب التوقف</h6>
                                            <h6 className="text-start">{pause?.pause_reason}</h6>
                                        </div>
                                        <div className="row my-3">
                                            <div style={{ borderInlineEnd: "2px solid #E8E8E8" }} className="col-md-4 col-12 d-flex justify-content-center">
                                                <div className="">
                                                    <h6 className="main-text-color">وقت التوقف</h6>
                                                    <h6 className="label-size fw-bold">{pause.paused_at ? new Date(pause.paused_at).toLocaleTimeString() : "-"}</h6>
                                                </div>

                                            </div>
                                            <div style={{ borderInlineEnd: "2px solid #E8E8E8" }} className="col-md-4 col-12 d-flex justify-content-center">
                                                <div className="">
                                                    <h6 className="main-text-color">مدة التوقف</h6>
                                                    <h6 className="label-size fw-bold">
                                                        {`${Math.round(pause?.duration / 60)} د`}
                                                    </h6>
                                                </div>

                                            </div>
                                            <div className="col-md-4 col-12 d-flex justify-content-center">
                                                <div className="">
                                                    <h6 className="main-text-color">وقت الاستمرار</h6>
                                                    <h6 className="label-size fw-bold">{pause?.resumed_at ? new Date(pause?.resumed_at).toLocaleTimeString() : "-"}</h6>
                                                </div>

                                            </div>
                                        </div>
                                    </div>)

                            }
                            {orderItemData?.executions?.rejected_reason &&
                                <div style={{ borderBlockEnd: "2px solid #E8E8E8" }} className="my-3 pb-2">
                                    <h6 className="main-text-color">سبب  رفض الخدمة</h6>
                                    <h6 className="">{orderItemData?.executions?.rejected_reason}</h6>
                                </div>

                            }
                            {orderItemData?.executions?.failed_reason &&
                                <div style={{ borderBlockEnd: "2px solid #E8E8E8" }} className="my-3 pb-2">
                                    <h6 className="main-text-color">سبب  فشل الخدمة</h6>
                                    <h6 className="">{orderItemData?.executions?.failed_reason}</h6>
                                </div>

                            }
                            {orderItemData?.executions?.image_path &&
                                <>
                                    <div className="my-3 pb-2">
                                        <h6 className="main-text-color">الصور</h6>
                                        <div className="row">
                                            <div className="col-12 ">
                                                <div className="w-100 d-flex justify-content-center">
                                                    <img style={{ width: "30%", cursor: "pointer" }} src={`${newImageUrl}/storage/${orderItemData?.executions?.image_path}`}

                                                        onClick={() => {
                                                            setSelectedImage(`${newImageUrl}/storage/${orderItemData?.executions?.image_path}`);
                                                            setOpenImage(true);
                                                        }}
                                                        alt="" />
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <Dialog
                                        open={openImage}
                                        onClose={() => setOpenImage(false)}
                                        fullScreen
                                        PaperProps={{
                                            sx: {
                                                backgroundColor: "rgba(0,0,0,0.95)",
                                            },
                                        }}
                                    >
                                        <IconButton
                                            onClick={() => setOpenImage(false)}
                                            sx={{
                                                position: "absolute",
                                                top: 16,
                                                right: 16,
                                                color: "#fff",
                                                zIndex: 10,
                                            }}
                                        >
                                            <CloseIcon fontSize="large" />
                                        </IconButton>
                                        <IconButton
                                            onClick={() => setOpenImage(false)}
                                            sx={{
                                                position: "absolute",
                                                top: 16,
                                                left: 16,
                                                color: "#fff",
                                                zIndex: 10,
                                            }}
                                        >
                                            <ArrowBackIcon fontSize="large" />
                                        </IconButton>

                                        <Box
                                            sx={{
                                                width: "100vw",
                                                height: "100vh",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <img
                                                src={selectedImage}
                                                alt=""
                                                style={{
                                                    width: "70%",
                                                    maxHeight: "500px",
                                                    objectFit: "fill",
                                                }}
                                            />
                                        </Box>
                                    </Dialog>
                                </>
                            }



                        </div>
                    </div>
                </Modal.Body>

            </Modal>
            <Modal show={pauseReasonShow} onHide={handlePauseReasonClose} dialogClassName='custom-modal-campaigns-width'>
                <Modal.Header className='d-flex align-items-center' >
                    <Modal.Title style={{ direction: "rtl" }} className='fw-bold fs-5 text-center w-100 m-0'>
                        سبب الايقاف المؤقت
                    </Modal.Title>

                </Modal.Header>
                <Modal.Body className='m-2' style={{ direction: "rtl" }}>
                    <div className="main-text-color">
                        يرجي تحديد سبب ايقاف الخدمة مؤقتا
                    </div>
                    {pauseReasons.map((reason) => {

                        return (
                            <>
                                <label

                                    key={reason.id}
                                    style={{
                                        paddingBlock: 10,
                                        border:
                                            selectedReason?.reason_en === reason.reason_en
                                                ? "3px solid #3FBEAC"
                                                : "1px solid #E8E8E8",
                                        backgroundColor:
                                            selectedReason?.reason_en === reason.reason_en
                                                ? "#D8F3EF4D"
                                                : "transparent",
                                        cursor: "pointer",
                                    }}
                                    htmlFor={reason.id} className="rounded-3 px-3 my-3 w-100 d-flex justify-content-between align-items-center">
                                    <div className="d-flex gap-2 align-items-center">
                                        <div className="">
                                            <img src={`${newImageUrl}${reason.icon_url}`} alt="" />
                                            {reason.icon}
                                        </div>
                                        <div className="">
                                            <p className="m-0 main-text-color">{reason.reason_ar}</p>
                                        </div>
                                    </div>
                                    <div className="">
                                        <input onChange={(e) => reasonChange(reason)
                                        } checked={selectedReason?.reason_ar === reason.reason_ar} id={reason.id} type="radio" style={{ accentColor: "#000", }} name='reason' />
                                    </div>
                                </label>

                            </>
                        )
                    }




                    )}
                    {selectedReason?.reason_en === "Other" &&

                        <div className="my-3">
                            <textarea
                                className="form-control mb-3"
                                rows={3}
                                placeholder="اكتب السبب ..."
                                onChange={(e) => otherReasonChange(e.target.value)}

                            />

                        </div>
                    }
                    <div className="d-flex justify-content-center align-items-center gap-3 mt-5">
                        <button onClick={() => handlePause()} className='btn btn-dark px-4 py-2 '>تأكيد الايقاف المؤقت</button>
                        <button onClick={handlePauseReasonClose} className='btn btn-light px-5 py-2'>الغاء</button>
                    </div>

                </Modal.Body>

            </Modal>
            <Modal show={showExecuteModal} onHide={handleCloseModal} dialogClassName='custom-modal-campaigns-width'>
                <Modal.Header className='d-flex align-items-center' >
                    <Modal.Title className='fw-bold fs-5 text-center m-0'>
                        تأكيد إنهاء الطلب
                    </Modal.Title>

                </Modal.Header>
                <Modal.Body className='m-2' style={{ direction: "rtl" }}>
                    <div className="text-center">
                        <h5 className='main-modal-color'>هل أنت متأكد من إنهاء هذا الطلب؟ سيتم حفظ جميع البيانات وإغلاق الطلب بعد تأكيدك.</h5>
                    </div>
                    <div className='my-4'>
                        <h6>
                            يرجى التأكد من الآتي قبل الإنهاء:
                        </h6>
                        <ul className='mx-4' style={{ listStyleType: "square", color: "#535353" }}>
                            <li className='my-2'>تم تنفيذ جميع الخدمات المطلوبة.</li>
                            <li className='my-2'>تم مراجعة التنفيذ بدقة.</li>
                            <li className='my-2'>لا توجد ملاحظات أو خدمات ناقصة.</li>
                        </ul>
                    </div>

                    <div className="d-flex justify-content-center align-items-center  gap-4">

                        <button onClick={endOrderExecution} className="btn btn-dark px-4">تأكيد وانهاء الطلب</button>
                        <button onClick={handleCloseModal} className="btn btn-light px-5">الغاء</button>

                    </div>
                </Modal.Body>

            </Modal>
            <Modal show={rejectFailModal.show} onHide={closeReasonModal} dialogClassName='custom-modal-campaigns-width'>
                <Modal.Header className='d-flex align-items-center' >
                    <Modal.Title style={{ direction: "rtl" }} className='fw-bold fs-5 text-center w-100 m-0'>
                        {rejectFailModal.mode === "rejected" ? "سبب رفض الخدمة" : "إضافة تفاصيل للخدمه"}
                    </Modal.Title>

                </Modal.Header>
                <Modal.Body className='m-2' style={{ direction: "rtl" }}>

                    <div className="">
                        <h6>

                            اكتب ملاحظة أو ارفع صورة للجزء في حالة وجود مشكله
                        </h6>

                        <textarea value={rejectFailModal.note} onChange={(e) => setRejectFailModal(prev => ({ ...prev, note: e.target.value }))} style={{ padding: 20, borderRadius: 10, border: "solid 2px #D8D8D8", }} rows={4} className='w-100' placeholder='اضف ملاحظاتك' id=""></textarea>


                    </div>
                    <div className='my-3'>
                        <p>اضافة مرفقات</p>

                        {rejectFailModal.imagePreview ? (

                            <div
                                className="position-relative w-100"
                                style={{ border: "2px dashed #C6C6C6", borderRadius: 10 }}
                            >
                                <Badge
                                    overlap="rectangular"
                                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                                    sx={{ width: "100%", display: "block" }}
                                    badgeContent={
                                        <IconButton
                                            size="small"
                                            onClick={handleRemoveReasonImage}
                                            sx={{
                                                backgroundColor: "#fff",
                                                boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                                                padding: "3px",
                                                "&:hover": { backgroundColor: "#f2f2f2" },
                                            }}
                                        >
                                            <CloseIcon sx={{ fontSize: 16, color: "#A80101" }} />
                                        </IconButton>
                                    }
                                >
                                    <img
                                        src={rejectFailModal.imagePreview}
                                        alt="preview"
                                        style={{
                                            width: "100%",
                                            height: 150,
                                            objectFit: "fill",
                                            borderRadius: 10,
                                            display: "block",
                                        }}
                                    />
                                </Badge>
                            </div>
                        )
                            :
                            <label className="cursor w-100" htmlFor="upload-file-reason">
                                <div style={{ border: "2px dashed #C6C6C6" }} className="p-4 w-100 rounded-3 d-flex justify-content-center align-items-center">
                                    <div className='text-center'>
                                        <DriveFolderUpload sx={{ fontSize: "50px", color: "#535353" }} />
                                        <p style={{ color: "#535353", margin: 0 }}>اضف ملف </p>
                                    </div>
                                </div>
                            </label>
                        }


                        <input
                            type="file"
                            accept="image/*"
                            onChange={ReasonFileChange}
                            ref={fileInputFailedRef}
                            className="d-none"
                            id="upload-file-reason"
                        />

                    </div>


                    <div className="d-flex justify-content-center align-items-center my-5 gap-4">
                        {rejectFailModal.isSaved ?
                            <button onClick={submitRejectFailAction} className="btn btn-dark px-4">
                                {rejectFailModal.mode === "rejected" ? "تأكيد الرفض" : "انهاء الخدمة"}
                            </button>

                            :

                            <button onClick={() => saveReasonNote(rejectFailModal.note)} className="btn btn-dark px-4">حفظ</button>
                        }
                    </div>

                </Modal.Body>

            </Modal>
            <Modal show={showModal} onHide={closeModal} dialogClassName='custom-modal-campaigns-width'>
                <Modal.Header className='d-flex align-items-center' >
                    <Modal.Title style={{ direction: "rtl" }} className='fw-bold fs-5 text-center w-100 m-0'>
                        إضافة تفاصيل للخدمه
                    </Modal.Title>

                </Modal.Header>
                <Modal.Body className='m-2' style={{ direction: "rtl" }}>

                    <div className="">
                        <h6>
                            اكتب ملاحظة
                        </h6>

                        <textarea value={noteValue} onChange={(e) => setNoteValue(e.target.value)} style={{ padding: 20, borderRadius: 10, border: "solid 2px #D8D8D8", }} rows={4} className='w-100' placeholder='اضف ملاحظاتك' id=""></textarea>


                    </div>


                    <div className="d-flex justify-content-center align-items-center my-5 gap-4">
                        <button onClick={saveNote} className="btn btn-dark px-4">حفظ الفحص</button>
                    </div>

                </Modal.Body>

            </Modal>
            <div className="m-4" dir="rtl">
                {loading || !order &&
                    <div className="text-center my-5">Loading...</div>
                }
                <div className="border rounded-4 min-vh-100">
                    <div className="border rounded-4 p-4">
                        <p className="m-0 fw-semibold">{`خدمات الطلب ${order?.reference ? order.reference : order?.id}`}</p>
                    </div>
                    <div className="p-4">


                        {order?.categories?.map(category => {
                            const isOtherCategory = category.slug === "cover";

                            return category.subcategories?.map(sub => {

                                const acceptedOtherServices = isOtherCategory
                                    ? sub?.items.filter(service => service.status === "accepted_by_user"
                                    )

                                    : [];

                                if (
                                    isOtherCategory &&
                                    acceptedOtherServices.length === 0
                                ) {
                                    return null;
                                }

                                return (

                                    <>
                                        <Accordion
                                            key={sub.id}
                                            expanded={expandedOrder === sub.id}
                                            onChange={() =>
                                                setExpandedOrder(
                                                    expandedOrder === sub.id ? null : sub.id,
                                                )
                                            }
                                            sx={{
                                                backgroundColor: "#F9F9F9",
                                                my: 2,
                                                py: 1,
                                                border: "none",
                                                outline: "none",
                                                "&:before": {
                                                    display: "none",
                                                },
                                                "&.Mui-expanded": {
                                                    boxShadow: "none",
                                                },
                                            }}
                                            className="shadow-sm"
                                        >
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                <div className="row w-100 align-items-center">
                                                    <div className="col-12 d-flex align-items-center justify-content-between">
                                                        <div className="d-flex align-items-center gap-1">
                                                            <div className="services-images-url">
                                                                <img
                                                                    src={
                                                                        category.icon_url
                                                                            ? isOtherCategory
                                                                                ? category.icon_url
                                                                                : `${newImageUrl}${category.icon_url}`
                                                                            : defaultImage
                                                                    }
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <span className="fw-bold mx-2">{sub.name}</span>
                                                        </div>
                                                        <div className="">
                                                            <span className="main-text-color label-size">
                                                                {`مكتملة ${category.slug === "maintainance" ? category.executed_items_count : sub.executed_items_count} / ${category.slug === "cover" ? sub.approved_items_count : category.slug === "maintainance" ? category.stuff_items_count : sub.items_count}`}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </AccordionSummary>

                                            <AccordionDetails>
                                                {!isOtherCategory &&
                                                    sub.items
                                                        ?.filter(item => item.item_type !== "other_request_service")
                                                        .map(service => renderServiceRow(service))}



                                                {isOtherCategory &&
                                                    acceptedOtherServices.map(service =>
                                                        renderServiceRow(service)
                                                    )}

                                            </AccordionDetails>
                                        </Accordion>
                                    </>
                                );
                            });
                        })}
                    </div>

                </div>
                <div className="d-flex justify-content-center mt-3 fixed-footer w-100">
                    {allowedStatuses.includes(order?.status) && (
                        <button
                            className='btn btn-dark px-5 w-75'
                            disabled={order.status === "in_progress" && !isAllItemsDone}
                            onClick={handleAction}
                        >
                            {order.status === "arrived_at_location" && "صور قبل التنفيذ"}

                            {order.status === "in_progress" && !isAfterImagesUploaded && "صور بعد التنفيذ"}

                            {order.status === "in_progress" && isAfterImagesUploaded && "انهاء تنفيذ الطلب"}

                            {order.status === "awaiting_payment" && "تأكيد تنفيذ الطلب"}
                        </button>

                    )}

                </div>
            </div>

        </>
    )
}

export default ExecuteByService
